<template>
    <a :href="item.url" target="_blank" class="w-list-item">
        <div class="w-o-grid w-list-item__inner">
            <div class="w-list-item__title w-o-cell">
                <span class="w-o-format-h3">{{ item.name }}</span>
            </div>
            <!-- <pre class="w-list-item__details w-o-cell">
                {{ item }}
            </pre> -->
            <div class="w-list-item__category w-o-cell">
                <span class="w-o-format-small">{{ item.category }}</span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: 'ListItem',
    props: {
        item: null,
    },
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
// @import "@/styles/objects/_format.scss";

.w-list-item {}
.w-list-item__inner {
    height: 100%;
    border: 1px solid w-get-color("bordergray");
    background-color: w-get-color("white");

    display: flex;
    flex-direction: column;

    .w-list-item:focus &,
    .w-list-item:hover & {
        border-color: w-get-color("green");
    }
}
.w-list-item__title {
    flex: 1 1 auto;
}
.w-list-item__details {
    flex: 0 0 auto;

    div {
        border: 1px solid blue;
        padding: 0.25em;
    }
}
.w-list-item__category {
    flex: 0 0 auto;
    color: w-get-color("darkgray");
}
</style>
